import { render, staticRenderFns } from "./StaffingScenarios.vue?vue&type=template&id=ac1bf1fa&"
import script from "./StaffingScenarios.vue?vue&type=script&lang=js&"
export * from "./StaffingScenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports